
import React from "react";
import {
    PulseLoader
} from "react-spinners";
import DIContainer from "../../../config/di.container";
import DITYPES from "../../../config/di.types";
import NotificationService from "../../../services/NotificationService";

const override = `
margin-right: auto;
margin-left: auto;
display: block;
width: 75px;
margin-top: 50vh;`
    ;

class LoaderContainer extends React.Component<{}, { loading: boolean, color: string }> {
    notificationService: any;

    constructor(props) {       
        super(props);
        this.state = {
            loading: false,
            color: "#29545e"
        }
        this.notificationService = DIContainer.get<NotificationService>(DITYPES.NotificationService);
        this.subscribeToSpinner();
    }

    public subscribeToSpinner() {
        this.notificationService?.progressNotification?.subscribe((isActive: boolean) => {
            this.setState((prevState: any) => ({
                ...prevState,
                loading: isActive
            }));
        }
        )
    }


    render() {
        return this.state.loading ? (<div className="loader-container">
            <PulseLoader
                css={override} color={this.state.color} loading={this.state.loading} size={20} />
        </div>) : null;
    }
}

export default LoaderContainer;